function Darkness() {
  return (
    <>
      <div className="absolute inset-x-1/4 top-0 h-full spotlight opacity-60" />
      <div className="absolute left-1/2 top-1/2 h-56 w-56 -translate-x-1/2 -translate-y-1/2 rounded-full bg-black shadow-[0_0_120px_rgba(0,0,0,1)]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,rgba(0,0,0,.1)_24%,rgba(0,0,0,.84)_74%)]" />
    </>
  );
}

function Depth() {
  return (
    <>
      <div className="absolute inset-0 bg-gradient-to-b from-museum-blue/35 via-museum-black to-black" />
      {Array.from({ length: 20 }).map((_, index) => (
        <span key={index} className="absolute h-1 w-1 rounded-full bg-museum-bone/35" style={{ left: `${8 + ((index * 13) % 84)}%`, top: `${10 + ((index * 19) % 78)}%` }} />
      ))}
      <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-b from-transparent to-black" />
    </>
  );
}

function Failure() {
  return (
    <>
      {Array.from({ length: 7 }).map((_, index) => (
        <div key={index} className="absolute border border-museum-bone/20" style={{ width: `${70 + index * 16}px`, height: `${48 + index * 10}px`, left: `${10 + index * 10}%`, top: `${18 + (index % 3) * 18}%`, transform: `rotate(${index % 2 ? -8 : 7}deg)` }} />
      ))}
      <div className="absolute left-[20%] top-[70%] h-px w-48 bg-museum-red/70" />
      <div className="absolute right-[18%] top-[30%] h-px w-32 bg-museum-gold/50" />
    </>
  );
}

function Abandonment() {
  return (
    <>
      <div className="absolute inset-0 bg-radial from-museum-purple/10 to-transparent" />
      {Array.from({ length: 5 }).map((_, index) => (
        <div key={index} className="absolute bottom-[22%] h-16 w-10 border border-museum-bone/14 bg-museum-black/40" style={{ left: `${18 + index * 14}%`, opacity: index === 2 ? 0.25 : 0.65 }} />
      ))}
      <div className="absolute bottom-[18%] left-[12%] h-px w-[76%] bg-museum-bone/10" />
    </>
  );
}

function Loss() {
  return (
    <>
      {Array.from({ length: 8 }).map((_, index) => (
        <div key={index} className="absolute border border-museum-bone/10" style={{ width: `${48 + index * 10}px`, height: `${62 + index * 8}px`, left: `${8 + ((index * 12) % 76)}%`, top: `${12 + ((index * 17) % 58)}%`, opacity: 0.5 - index * 0.04 }} />
      ))}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-museum-bone/5 to-transparent" />
    </>
  );
}

function Time() {
  return (
    <>
      <div className="absolute left-1/2 top-1/2 h-64 w-64 -translate-x-1/2 -translate-y-1/2 rounded-full border border-museum-gold/25" />
      <div className="absolute left-1/2 top-1/2 h-44 w-44 -translate-x-1/2 -translate-y-1/2 rounded-full border border-museum-bone/10" />
      <div className="absolute left-1/2 top-1/2 h-px w-32 origin-left bg-museum-gold/70 motion-safe:animate-[slow-spin_18s_linear_infinite]" />
      <div className="absolute left-1/2 top-1/2 h-px w-24 origin-left bg-museum-bone/35 motion-safe:animate-[slow-spin_42s_linear_infinite]" />
    </>
  );
}

function Silence() {
  return (
    <>
      <div className="absolute inset-12 rounded-full border border-museum-bone/8" />
      <div className="absolute left-[10%] top-1/2 h-px w-[80%] bg-gradient-to-r from-transparent via-museum-blue/55 to-transparent" />
      <div className="absolute left-[18%] top-[54%] h-px w-[64%] bg-gradient-to-r from-transparent via-museum-bone/20 to-transparent" />
    </>
  );
}

function Crowd() {
  return (
    <>
      {Array.from({ length: 78 }).map((_, index) => (
        <span key={index} className={`absolute h-2 w-2 rounded-full ${index === 37 ? "bg-museum-gold" : "bg-museum-bone/25"}`} style={{ left: `${5 + ((index * 11) % 90)}%`, top: `${8 + ((index * 23) % 82)}%` }} />
      ))}
    </>
  );
}

function Control() {
  return (
    <>
      <div className="absolute inset-8 grid grid-cols-5 gap-3 opacity-70">
        {Array.from({ length: 25 }).map((_, index) => (
          <div key={index} className={`rounded border ${index % 7 === 0 ? "border-museum-gold/60 bg-museum-gold/10" : "border-museum-bone/10 bg-museum-black/30"}`} />
        ))}
      </div>
      <div className="absolute left-[18%] top-[46%] h-2 w-[64%] rounded-full bg-museum-bone/10" />
      <div className="absolute left-[52%] top-[43%] h-8 w-8 rounded-full border border-museum-gold/60 bg-museum-black" />
    </>
  );
}

function Death() {
  return (
    <>
      <div className="absolute inset-0 bg-gradient-to-b from-museum-black via-black to-black" />
      <div className="absolute left-[12%] top-[55%] h-px w-[76%] bg-museum-bone/55" />
      <div className="absolute inset-x-0 top-[56%] h-36 bg-gradient-to-b from-museum-bone/5 to-transparent" />
    </>
  );
}

function Mirror() {
  return (
    <>
      <div className="absolute left-1/2 top-0 h-full w-px bg-museum-gold/40" />
      <div className="absolute left-[18%] top-[25%] h-48 w-24 rounded-full border border-museum-bone/20 bg-museum-blue/10" />
      <div className="absolute right-[18%] top-[25%] h-48 w-24 rounded-full border border-museum-bone/20 bg-museum-purple/10" />
      <div className="absolute left-[28%] top-[42%] h-px w-[44%] bg-museum-bone/15" />
    </>
  );
}

function Unknown() {
  return (
    <>
      <div className="absolute left-1/2 top-1/2 h-64 w-36 -translate-x-1/2 -translate-y-1/2 rounded-t-full border border-museum-gold/45 bg-museum-black/55 shadow-glow" />
      <div className="absolute left-1/2 top-1/2 h-52 w-24 -translate-x-1/2 -translate-y-1/2 rounded-t-full border border-museum-bone/10" />
      <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-black to-transparent" />
    </>
  );
}

function Body() {
  return (
    <>
      <div className="absolute left-1/2 top-1/2 h-56 w-72 -translate-x-1/2 -translate-y-1/2 rounded-[45%] border border-museum-red/35 bg-museum-red/5 motion-safe:animate-[pulse-soft_5s_ease-in-out_infinite]" />
      <div className="absolute left-[22%] top-[48%] h-px w-[56%] bg-gradient-to-r from-transparent via-museum-red/60 to-transparent" />
      <div className="absolute left-[30%] top-[40%] h-px w-[38%] rotate-6 bg-gradient-to-r from-transparent via-museum-bone/25 to-transparent" />
    </>
  );
}

const atmosphereViews = {
  darkness: Darkness,
  depth: Depth,
  failure: Failure,
  abandonment: Abandonment,
  loss: Loss,
  time: Time,
  silence: Silence,
  crowd: Crowd,
  control: Control,
  death: Death,
  mirror: Mirror,
  unknown: Unknown,
  body: Body
};

function RoomAtmosphere({ type }) {
  const View = atmosphereViews[type] || Unknown;

  return (
    <div className="relative min-h-[360px] overflow-hidden rounded-lg soft-border bg-museum-black shadow-museum lg:min-h-[620px]" aria-hidden="true">
      <View />
      <div className="fog-layer opacity-60" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,rgba(0,0,0,.12)_40%,rgba(0,0,0,.75)_100%)]" />
    </div>
  );
}

export default RoomAtmosphere;
